const useApiOperation = (settings) => {
  
  const getRequest = (apiSettings) => {
    var request = {url:apiSettings.value, settings:{method:apiSettings.method } }
    
    settings.forEach(setting => {
      if (setting == "Body") {
        let option = apiSettings[setting] ? apiSettings[setting].option : undefined
        if (option) {
          if(option == "raw")
            request.settings[setting.toLowerCase()] = setting.value
          else
          if (apiSettings[setting][option].details && apiSettings[setting][option].details.length>0)
            buildSettings(apiSettings[setting][option].details, request.settings, setting) 
        }
      } if (setting == "Params") {
        if (apiSettings[setting] && apiSettings[setting].details && apiSettings[setting].details.length>0)
          buildParams(apiSettings[setting].details, request)   
      }
      else
        if (apiSettings[setting] && apiSettings[setting].details && apiSettings[setting].details.length>0)
          buildSettings(apiSettings[setting].details, request.settings, setting)
    });
    return request
  };

  const buildSettings = (details, result, settings) => {
    details.forEach(detail => {
      let settingToUpdate = settings
      if (settings == "Authorization") settingToUpdate = detail.destination.value
      result[settingToUpdate.toLowerCase()]  = {...result[settingToUpdate] , [detail.key.value]:detail.value.value}
    });
    
  };

  const buildParams = (details, result) => {
    details.forEach((detail,index) => {
      result.url  = result.url + (index == 0 ? "?" : "&" ) + detail.key.value + "=" + detail.value.value
    });
    
  };

  const call = (apiSettings) => {
    
    var request = getRequest(apiSettings)
    
    
    return fetch(request.url, request.settings)
      .then((response) =>  response.json())
      .then(result => { return result })
      .catch((error) => { return error });

     
  };
  
  return call;
};

export default useApiOperation;
